// extracted by mini-css-extract-plugin
export default {"bottomSheet":"sc5A9N","titleColor":"Hk8c1d","oneLiteLogo":"WSBVIs","deliveryExecutive":"EBr9Dg","closeButton":"cKxc89","closeButtonLite":"Hvw_Kj"};